export class SscResponse {
    public sscresponse: {
        data: any;
        errorcode: number;
        errordesc: string;
    };
}
